export default "__VITE_ASSET__ZX$jHUwR__"